<div class="card">
    <div class="card-body">
        <div class="mb-4 d-md-flex align-items-center justify-content-between">
            <div>
                <h4><span >Import Data</span></h4>
                <p class="new-project-sub-line">Basic info, like your name and address on this account.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <a href="{{apiUrl}}" download >Download Sample File</a>
                <form [formGroup]="formGroup" (submit)="onSubmit()" class="download-file-form">
                    <div class="row">
                        <div class="col form-group mb-3">
                            <ng-select 
                                [items]="formList"
                                bindLabel="formName"
                                bindValue="formUrl"
				                placeholder="Select Form Name"
                                formControlName="formName"
                            >
                            </ng-select>
                            <input type="text" style="margin-top: 15px;" placeholder="Enter New Form Name" *ngIf="this.formGroup.get('formName').value == 'Other'" class="form-control" formControlName="otherName">
                        </div>
                        <div class="col form-group mb-3">
                            <input type="file" class="form-control" placeholder="Upload File" accept=".csv" formControlName="file" (change)="onFileSelected($event)">
                        </div>
                    </div>
                    <div class="text-end">
                        <button class="btn btn-primary ml-2" type="submit">Import</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>